import usePrivateAxios from "@/common/api/usePrivateAxios"
import { useMutation } from "@tanstack/react-query"

interface UseAdvancePrivateCompanyLeadContactProps {
  contactId?: string
  onSuccess?: () => void
  onError?: () => void
}

export const useAdvanceContact = ({ contactId, onSuccess, onError }: UseAdvancePrivateCompanyLeadContactProps) => {
  const privateAxios = usePrivateAxios()
  return useMutation({
    mutationKey: ['advancePrivateCompanyLeadContact'],
    mutationFn: async () => {
      await privateAxios.put(`/funnel/contacts/${contactId}/advance`)
    },
    onSuccess,
    onError,
  })
}
